import styled from 'styled-components';

const LogoWrapper = styled.div``;

const ImagePreviewWrapper = styled.div`
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(7, 1fr);
  margin-top: 16px;
`;

export { ImagePreviewWrapper, LogoWrapper };
